import React from 'react';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import styled from 'styled-components';
import { SvgIcon } from '../../Icon';
import { theme } from '../../../styles/theme';

interface IProps {
  dragHandleProps: DraggableProvidedDragHandleProps;
  visible: boolean;
}

const Container = styled.button`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  color: ${theme.colors.secondary600};
  transition: opacity 0.2s ease-in-out;
  &:hover {
    cursor: grab;
    color: ${theme.colors.mainBlue};
  }
`;

const DragHandle = ({ dragHandleProps, visible }: IProps) => (
  <Container
    type="button"
    {...dragHandleProps}
    style={{ opacity: visible ? 1 : 0 }}
  >
    <SvgIcon
      name="drag-drop"
      width={12}
      height={12}
      customFill="currentColor"
    />
  </Container>
);

export default DragHandle;
